import { lazy } from 'react';

export const SbSharedRefineMenuShippingFiltersWrapperLazy = lazy(
    () =>
        import(
            /* webpackChunkName: "SbSharedRefineMenuShippingFilters" */ '../SbSharedRefineMenuShippingFilters/SbSharedRefineMenuShippingFiltersWrapper.jsx'
        )
);
